import { useLiveQuery } from 'dexie-react-hooks';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { changeFile, deleteFile as deleteFileApi } from '../../../api/ans';
import cancelicon from '../../../assets/images/cancelIcon.svg';
import { closePopup, openPopup } from '../../../store/slices/popupSlice';
import { db, deleteFileFromDb, saveFile, updateFile } from '../../../utils/db';
import { getTotalCopies } from '../../../utils/functions';
import FileItem from '../../FileItem/FileItem';
import GreyButton from '../../ui/buttons/greyButton/GreyButton';
import RedButton from '../../ui/buttons/redButton/RedButton';
import UploadZone from '../../UploadZone/UploadZone';
import styles from './styles/styles.module.css';

function SelectStickersPopup({ serverRefs = [] }) {
  const MAX_SIZE = 50 * 1024 * 1024;
  const dispatch = useDispatch();
  const methods = useForm({});

  const [stickers, setStickers] = useState([]);
  // Ошибка операции показывается прямо внутри попапа, а не через
  // openPopup('error') - иначе попап стикеров закроется (в сторе может
  // быть только один активный попап) и пользователь потеряет своё место.
  const [actionError, setActionError] = useState('');

  const [stickersCopy] = useState([]);

  const stickersDb = useLiveQuery(() => db.files.toArray(), []);

  // stickersDb приходит из useLiveQuery (реактивное чтение IndexedDB) -
  // внешняя система, не props/state. stickers также мутируется локально в
  // других местах файла (изменение копий, удаление), это не чистая
  // производная от stickersDb.
  useEffect(() => {
    if (stickersDb) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- см. выше
      setStickers(stickersDb);
    }
  }, [stickersDb]);

  console.log(stickers, stickersCopy);

  const { handleSubmit } = methods;

  const onSubmit = () => {
    console.log(stickers);
  };

  // Для стикера, который уже лежит на сервере (isEdit), сначала пробуем
  // изменить количество копий там, и только при успехе меняем локально.
  // Раньше локальное состояние менялось всегда, а ошибка сервера нигде
  // не обрабатывалась - из-за этого счётчик визуально менялся, но после
  // повторного открытия заказа возвращался к прежнему значению.
  // Показывает, принадлежит ли ref текущему документу. Если нет - значит
  // в IndexedDB остался стикер от другого заказа, и проблема на фронте.
  // Если да, а бэкенд всё равно "не находит" файл - проблема на бэкенде.
  const describeRef = (id) => {
    const belongs = serverRefs.some((r) => r === id);
    return `file_ref: ${JSON.stringify(id)} (${typeof id}), в текущей заявке: ${
      belongs ? 'ДА' : 'НЕТ'
    }`;
  };

  const setCopiesStickers = async (id, value, isEdit) => {
    if (isEdit) {
      try {
        await changeFile({ file_ref: id, copies_count: value });
      } catch (error) {
        console.error('Ошибка изменения количества копий стикера', id, error);
        setActionError(
          `${error.response?.data?.message || 'Не удалось изменить количество копий.'} [${describeRef(id)}]`
        );
        return;
      }
    }

    setActionError('');
    updateFile(id, { copies: value });
    setStickers((prev) =>
      prev.map((item) => (item.id === id ? { ...item, copies: value } : item))
    );
  };

  // Та же логика для удаления: пока сервер не подтвердил, из списка и из
  // IndexedDB стикер не убираем, иначе он "исчезает" и возвращается при
  // следующем открытии заказа.
  const handleDeleteSticker = async (id, hasServerRef) => {
    if (hasServerRef) {
      try {
        await deleteFileApi({ file_ref: id });
      } catch (error) {
        console.error('Ошибка удаления стикера', id, error);
        setActionError(
          `${error.response?.data?.message || 'Не удалось удалить стикер.'} [${describeRef(id)}]`
        );
        return;
      }
    }

    setActionError('');
    setStickers((prev) => prev.filter((f) => f.id !== id));
    deleteFileFromDb(id);
  };

  const handleStickersChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    const validFiles = selectedFiles.filter((file) => {
      const isPdfType = file.type === 'application/pdf';
      const isPdfExt = file.name.toLowerCase().endsWith('.pdf');

      if (!isPdfType && !isPdfExt) {
        console.log(`Файл "${file.name}" не является PDF`);
        dispatch(
          openPopup({
            name: 'error',
            props: {
              errorText: `Файл "${file.name}" не является PDF`,
              buttonText: 'Попробовать снова',
            },
          })
        );
        return false;
      }

      if (file.size > MAX_SIZE) {
        console.log(`Файл "${file.name}" больше 50MB`);
        dispatch(
          openPopup({
            name: 'error',
            props: {
              errorText: `Файл "${file.name}" больше 50MB`,
              buttonText: 'Попробовать снова',
            },
          })
        );
        return false;
      }

      return true;
    });

    const newFiles = validFiles.map((file) => ({
      id: `${file.name}_${file.size}_${file.lastModified}`,
      file,
      name: file.name,
      size: file.size,
      copies: 1,
    }));

    newFiles.forEach((file) => {
      saveFile(file);
    });

    setStickers((prev) => {
      const newStickers = validFiles.map((sticker) => ({
        id: `${sticker.name}_${sticker.size}_${sticker.lastModified}`,
        file: sticker,
        name: sticker.name,
        size: sticker.size,
        copies: 1,
      }));

      const combined = [...prev, ...newStickers];

      const uniqueFiles = combined.filter((item, index, arr) => {
        return arr.findIndex((f) => f.id === item.id) === index;
      });

      return uniqueFiles;
    });

    e.target.value = '';
  };

  return (
    <div className={styles.addAdressWrapper}>
      <div className={styles.AddClc}>
        <div>
          <h1 className={styles.headerAddAdress}>Стикеры</h1>
          <span>{`${stickers?.length || 0} стикеров, ${getTotalCopies(stickers)} копий к печати`}</span>
        </div>
        <img
          src={cancelicon}
          onClick={() => {
            dispatch(closePopup());
          }}
          height={24}
          width={24}
        />
      </div>
      <FormProvider {...methods}>
        <form className={styles.AddForm} onSubmit={handleSubmit(onSubmit)}>
          <UploadZone
            handleFileChange={handleStickersChange}
            type="stickersset"
            stickers={stickers}
          />
          <div className={styles.needDeliveryAddressInputs}>
            <div className={styles.AddDeteils}>
              {stickers.map((item) => (
                <FileItem
                  key={item.id}
                  id={item.id}
                  deleteFile={(id) => {
                    handleDeleteSticker(id, typeof item.ref === 'number');
                  }}
                  nameFile={item.name}
                  sizeFile={(item.size / (1024 * 1024)).toFixed(2)}
                  copies={item?.copies || item?.copies_count}
                  setCopies={setCopiesStickers}
                  isEdit={!('file' in item)}
                />
              ))}
            </div>
          </div>
          {actionError ? (
            <p role="alert" style={{ color: '#d32f2f', margin: '8px 0 0' }}>
              {actionError}
            </p>
          ) : null}
          <div className={styles.buttonsRos}>
            <GreyButton
              text="Отменить"
              width={246}
              height={56}
              onClick={() => {
                dispatch(closePopup());
              }}
            />
            <RedButton
              text="Сохранить"
              width={246}
              height={56}
              onClick={() => {
                console.log(stickers);
                stickers.forEach((sticker) => {
                  saveFile(sticker);
                });
                dispatch(closePopup());
              }}
            />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}

SelectStickersPopup.propTypes = {
  // refs стикеров, принадлежащих текущему документу (для диагностики)
  serverRefs: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
};

export default SelectStickersPopup;
